import React from 'react';
import PropTypes from 'prop-types';
import css from './DropdownButton.module.scss';

const ButtonDropdownItem = ({children, onClick, ...rest}) => (
  <div className={css.option} onClick={onClick} {...rest}>
    {children}
  </div>
);

ButtonDropdownItem.displayName = 'ButtonOption';

ButtonDropdownItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default ButtonDropdownItem;
